import * as React from 'react';
import { PriceContainer } from './components/Price';
import { SectionContainer } from '../Section';
import { BuyButtonContainer } from './components/BuyButton';

export const Footer = () => {
  return (
    <SectionContainer>
      <PriceContainer />

      <BuyButtonContainer />
    </SectionContainer>
  );
};
